export var STATE_DELIMITER = '.';
export var EMPTY_ACTIVITY_MAP = {};